/**
 * 创建人：王靖
 * 时间：2019-3-11
 * 描述：图片预览 
 * 使用说明: 参考 sw-photo-album 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import Viewer from 'viewerjs';

/**
 * 图片预览  不能直接使用 
 * 
 * 使用方式 SwPhotoAlbumService 服务 或者 SwAlbumDirective
 */
@Component({
  selector: 'sw-photo-album',
  templateUrl: './sw-photo-album.component.html',
  styleUrls: ['./sw-photo-album.component.css']
})
export class SwPhotoAlbumComponent implements OnInit {

  /**
   * 图片的数据对象  { path :["绝对地址","",""]，index：3}
   */
  @Input() photosData: any = {};
  /**
   * 关闭事件
   */
  @Output() voted = new EventEmitter();

  /**
   * 图片预览时添加的水印
   */
  @Input() watermark: string = ""

  /**
   * 自动轮播
   * @ignore
   */
  autoPlay:boolean;  

  /**
   * 自动轮播间隔时间
   * @ignore
   */
  intervalTime:number;  


  /**
   * @ignore
   */
  constructor(private el: ElementRef) { }

  /**
   * @ignore
   */
  ngOnInit() {
  }

  /**
   * @ignore
   */
  ngAfterViewInit(): void {
    const ViewerDom = document.getElementById('images')
    //清空div的内容
    ViewerDom.innerHTML = ""
    let html
    //遍历图片地址,创建dom元素添加到ul中去
    this.photosData.path.forEach(src=>{
       html += `<li><img data-original="${src}" src="${src}"></li>`

    })
    ViewerDom.innerHTML = html
    //创建预览对象
    let gallery = new Viewer(document.getElementById('images'),
    {
      // watermark:'数文科技',  //水印文字
      // watermark:'<img src=""/>',  //水印图片
      // applyBtn:false,    //申请按钮是否存在
      zIndex:11100,        //预览组件的层级
      navbar: true,
        zoomRatio: 0.4,
        button: true,
        title: false,
        keyboard: false,
        //轮播间隔时间
        interval:this.intervalTime,  
        show: function (){  
           // 动态加载图片后，更新实体
        gallery.update(); 
      },
      shown: function() {
      },
      view: function() {},
      viewed:function () {},
      hide: ()=>{
        //销毁预览对象
        gallery.destroy()  
        //销毁组件
        this.voted.emit(false)  
      },
      hidden: function() {},
      watermark:this.watermark
      //点击申请按钮的回调
      // apply:()=>{       
      //   console.log('点击申请按钮');
        
      // }
    });
    //看到的是第几张图片
    gallery.view(this.photosData.index)  
    //手动调用show方法
    gallery.show(true)  
    if(this.autoPlay){
      //自动轮播
      gallery.play(true)  
    }
  }

}
